export default "__VITE_ASSET__BwDLkj4t__"